import { render, staticRenderFns } from "./BlockType114.vue?vue&type=template&id=4bca688e&scoped=true"
import script from "./BlockType114.vue?vue&type=script&lang=ts"
export * from "./BlockType114.vue?vue&type=script&lang=ts"
import style0 from "./BlockType114.vue?vue&type=style&index=0&id=4bca688e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bca688e",
  null
  
)

export default component.exports